import type { LucideIcon } from 'lucide-react'
import './SegmentedControl.css'

/**
 * A segmented control, design.md 8.4: a pill container in the fill color, the chosen segment
 * raised on the surface color. A radio group underneath, so arrow keys move between
 * segments.
 */
export function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
  label,
}: {
  options: Array<{ value: T; label: string; icon?: LucideIcon }>
  value: T
  onChange: (value: T) => void
  /** The group's accessible name. */
  label: string
}) {
  return (
    <div className="segmented" role="radiogroup" aria-label={label}>
      {options.map((o) => (
        <label key={o.value} className={`seg ${o.value === value ? 'active' : ''}`}>
          <input type="radio" name={label} value={o.value} checked={o.value === value} onChange={() => onChange(o.value)} />
          {o.icon && <o.icon aria-hidden="true" />}
          {o.label}
        </label>
      ))}
    </div>
  )
}
